import { render, staticRenderFns } from "./risk-advisor-teams.vue?vue&type=template&id=23443adc"
import script from "./risk-advisor-teams.vue?vue&type=script&lang=js"
export * from "./risk-advisor-teams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports